<template>
  <div class="mailing-list">
    <loader :isLoading="isRequestInProgress"/>
    <h3>{{ header_text }}</h3>
    <h4>{{ sub_text }}</h4>
    <!-- <h4>No worries. Simply subscribe to our newsletters and we will get in touch.</h4> -->
    <form class="ml-form" @submit.prevent="validateBeforeSubmit()">
      <div>
        <input
          class="ml-email"
          name="email"
          type="email" v-model="email"
          placeholder="Enter your email address" />
        <input
          class="btn-primary"
          type="submit"
          @click="validateBeforeSubmit()"
          value="Subscribe" />
      </div>
      <section>
        <div>
          <small v-show="!this.isSuccess" class="form-text text-muted error-message">
            {{ error }}
          </small>
        </div>
        <br/>
        <div>
          <small class="form-text text-muted" data-type="message" v-if="this.isSuccess">
            Thank you for subscribing, we'll get back to you as soon as possible.
          </small>
        </div>
      </section>
    </form>
  </div>
</template>


<script>
import Loader from '@/components/common/Loader'

import { APIService } from '@/api/APIService'

const api = new APIService()

export default {
  name: 'mailing-list',
  components: {
    Loader
  },
  data() {
    return {
      email: '',
      error: '',
      isSuccess: false,
      isRequestInProgress: false,
    }
  },
  methods: {
    validateEmail(email) {
      var re = new RegExp('[^@]+@[^@]+\\.[^@]+')
      return re.test(email)
    },
    validateBeforeSubmit() {
      if(this.email.length === 0 || !this.validateEmail(this.email)) {
        this.error = 'Please enter valid email address'
        return
      }
      const fields = { Email: this.email }
      if(this.base_name.includes('Top')) {
        this.isRequestInProgress = true
        api.postToMailingListTop(fields)
        .then(d => { this.isSuccess = true })
        .catch(e => {
          this.error = 'Something went wrong, please try again.'
          this.isSuccess = false
        })
        .then(() => { this.isRequestInProgress = false })
      } else {
        this.isRequestInProgress = true
        api.postToMailingListBottom(fields)
        .then(d => { this.isSuccess = true })
        .catch(e => {
          this.error = 'Something went wrong, please try again.'
          this.isSuccess = false
        })
        .then(() => { this.isRequestInProgress = false })
      }
    }
  },
  props: {
    header_text: String,
    sub_text: String,
    base_name: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MailingList.vue